import * as React from 'react';
const SvgNoAccess = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={120}
    height={121}
    fill="none"
    viewBox="0 0 120 121"
    {...props}
  >
    <circle cx={60} cy={60.5} r={60} fill="#E0EBFF" />
    <circle cx={105} cy={82.25} r={2.25} fill="#85A3FF" />
    <path
      fill="#85A3FF"
      d="M91.754 21.618c.333-1.234 2.16-1.234 2.492 0l.175.647c.12.447.492.793.962.895l.363.078a1.224 1.224 0 0 1 0 2.409l-.362.078c-.471.102-.843.447-.963.895l-.175.647c-.332 1.234-2.16 1.234-2.492 0l-.174-.647a1.26 1.26 0 0 0-.963-.895l-.363-.079a1.224 1.224 0 0 1 0-2.408l.363-.078c.47-.102.842-.448.963-.895z"
    />
    <circle cx={66.75} cy={20.23} r={1.5} fill="#0A2FFF" />
    <path
      fill="#0A2FFF"
      d="M11.753 55.99c.266-.987 1.728-.987 1.994 0l.14.518c.096.358.393.634.77.716l.29.063a.98.98 0 0 1 0 1.926l-.29.063a1.01 1.01 0 0 0-.77.716l-.14.518c-.266.987-1.728.987-1.994 0l-.14-.518a1.01 1.01 0 0 0-.77-.716l-.29-.063a.98.98 0 0 1 0-1.926l.29-.063c.377-.081.674-.358.77-.716z"
    />
    <path
      fill="#0A2FFF"
      fillRule="evenodd"
      d="M69.75 42.5v-9.75c0-5.385-4.365-9.75-9.75-9.75s-9.75 4.365-9.75 9.75v9.75zM60 14c-10.355 0-18.75 8.395-18.75 18.75V51.5h37.5V32.75C78.75 22.395 70.355 14 60 14"
      clipRule="evenodd"
    />
    <path fill="#00078F" d="M41.25 41h9v-3h-9zM69.75 41h9v-3h-9z" />
    <g filter="url(#a)" opacity={0.5}>
      <path
        fill="#0014CC"
        d="M27.927 51.033A6 6 0 0 1 33.91 45.5H86.09a6 6 0 0 1 5.982 5.533l1.652 21.152q.025.315.004.63C92.554 90.366 77.975 104 60.386 104h-.772c-17.59 0-32.168-13.635-33.343-31.184q-.021-.316.004-.631z"
      />
    </g>
    <path
      fill="#fff"
      d="M28.008 46.25A5.625 5.625 0 0 1 33.62 41h52.76a5.625 5.625 0 0 1 5.612 5.25L93.75 72.5C92.563 90.227 77.767 104 60 104S27.437 90.227 26.25 72.5z"
    />
    <g filter="url(#b)" opacity={0.8}>
      <path
        stroke="#85A3FF"
        strokeWidth={16}
        d="M62.75 74.084a6 6 0 1 0-5.5 0l-1.556 7.259a.75.75 0 0 0 .734.907h7.144a.75.75 0 0 0 .734-.907z"
      />
    </g>
    <path
      fill="#0014CC"
      d="M62.75 74.084a6 6 0 1 0-5.5 0l-1.556 7.259a.75.75 0 0 0 .734.907h7.144a.75.75 0 0 0 .734-.907z"
    />
    <circle cx={100.5} cy={31.48} r={1.5} fill="#0A2FFF" />
    <defs>
      <filter
        id="a"
        width={93.477}
        height={84.5}
        x={13.261}
        y={32.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_1120_6681"
          stdDeviation={6.5}
        />
      </filter>
      <filter
        id="b"
        width={76}
        height={83.5}
        x={22}
        y={30.75}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_1120_6681"
          stdDeviation={12}
        />
      </filter>
    </defs>
  </svg>
);
export default SvgNoAccess;
